import React from "react";
import whatsapp from "../images/whatsapp.png";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const WhatsApp = () => {
  const {companyDetailsData} = useCompanyDetailsContext();
  return (
    <>
      <a
        href={`https://wa.me/${companyDetailsData[0]?.whatsapp_number}`}
        id="toTop"
        className="whatsapp-button"
        target="_blank"
        rel="noreferrer"
        style={{
          opacity: 1,
          visibility: "visible",
          background: "#25D366",
        //   borderRadius: "50%",
          borderRadius: "5px",
          transition: "transform 0.3s ease, width 0.3s ease, height 0.3s ease",
        }}
      >
        <img
          className="whatsapp-size-full wp-image-861 alignnone"
          src={whatsapp}
          alt="whatsapp"
        />
      </a>
    </>
  );
};

export default WhatsApp;
